<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <h2>Hot Parking</h2>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-5 ui-nopad">
      <p-dropdown [options]="companies" [(ngModel)]="selectedCompany" (onChange)="onCompanyChange($event)" placeholder="Wybierz firmę najemcy"></p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-5">
      <p-dropdown [options]="carparkUsers" [(ngModel)]="selectedCarparkUser" placeholder="Wybierz użytkownika"></p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-2" style="text-align: right;">
      <p-button class="button" type="button" [disabled]="!selectedCarparkUser" (click)="addHotParkingPosition()" label="Dodaj kartę do listy"></p-button>
    </div>
    <div style="clear: both;">
      <p-table #dt [value]="hotParkingList" [columns]="cols">
        <ng-template pTemplate="caption">
          <div style="text-align: right;">
            <fa-icon icon="search" style="margin: 4px 5px 0 0"></fa-icon>
            <input pInputText size="50" placeholder="filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width: auto;" />
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" width="{{col.width}}">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span *ngSwitchCase="'validUntil'">
                <span *ngIf="rowData.permanent">Bez terminu</span>
                <span *ngIf="!rowData.permanent">{{rowData[col.field] | date: 'yyyy-MM-dd'}}</span>
              </span>
              <span *ngSwitchCase="'presentOnParking'">{{rowData[col.field] ? 'Tak' : 'Nie'}}</span>
              <span *ngSwitchCase="'action'">
                <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="deleteHotParkingPosition(rowData)" title="Usuń">
                  <fa-icon icon="square" stackItemSize="2x"></fa-icon>
                  <fa-icon icon="times" [inverse]="true" stackItemSize="1x"></fa-icon>
                </fa-stack>
              </span>
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</div>
